module.exports = __webpack_public_path__ + "static/media/receipt.8dcbc9ed.svg";